import token, { tokenToVars } from '../token';
import Rate from './rate';

export { Rate };
export default tokenToVars(Rate, token);
